import { SurveyActionTypes } from './types';
import { createAsyncMapAction } from '~lib/shared/redux/actions';
export const listSurveysByUserId = createAsyncMapAction(SurveyActionTypes.LIST_SURVEYS_BY_USER_ID, p => p.userId);
export const submitSurvey = createAsyncMapAction(SurveyActionTypes.SUBMIT_SURVEY, p => p.requestId);
